<template>
  <v-ons-navigator id="app-navigator" swipeable
    :page-stack="pageStack"
    :pop-page="navigatorPopWrapper"
    @push-page="pageStack.push($event)"
    v-bind:class="{ darkmode: currentUser ? currentUser.dark_mode_enabled : $initDarkModeEnabled }"
  ></v-ons-navigator>
</template>

<style lang="scss">
@import './assets/css/main.css';
</style>

<script>
export default {
  computed: {
    pageStack() {
      return this.$store.state.navigator.stack;
    },
  },

  methods: {
    // default behavior when user click back
    navigatorPopWrapper() {
      this.navigatorPop();
    },
  }
};
</script>
